import React from "react";
import { Checkbox, Col, Row } from "antd";

import WaybillNoExportExportItem from "@/services/api/moreFeatures/shippingCostStat/enum/WaybillNoExportExportItem";
import WaybillNoExportExportItemNameMap from "@/services/api/moreFeatures/shippingCostStat/map/WaybillNoExportExportItemNameMap";
import styles from "../index.module.less";

export const WaybillNoExportExportProductFields = [
    WaybillNoExportExportItem.PRODUCT_TITLE,
    WaybillNoExportExportItem.PRODUCT_EXTERNAL_ID,
    WaybillNoExportExportItem.SKU_EXTERNAL_ID,
    WaybillNoExportExportItem.SKU_PROPERTIES_NAME,
    WaybillNoExportExportItem.SKU_QUANTITY,
    WaybillNoExportExportItem.SKU_WEIGHT,
];

interface WaybillFieldItemProps {
    value: WaybillNoExportExportItem;
    checked: boolean;
    disabled: boolean;
    editable: boolean;
}

const WaybillFieldItem: React.FC<WaybillFieldItemProps> = ({ value, checked, disabled, editable }) => {
    const label = WaybillNoExportExportItemNameMap[value];
    const innerCheckbox = (
        <Checkbox value={value} disabled={editable ? disabled : false} checked={checked}>
            {label}
        </Checkbox>
    );

    return (
        <Col className={styles.waybillFieldItem} key={value}>
            {editable ? innerCheckbox : <div style={{ pointerEvents: "none" }}>{innerCheckbox}</div>}
        </Col>
    );
};

interface WaybillFieldCheckboxGroupProps {
    value?: WaybillNoExportExportItem[];
    totalExportItems?: WaybillNoExportExportItem[];
    onChange?: (value: WaybillNoExportExportItem[]) => void;
    needProductInfo: boolean;
    editable: boolean;
}

export const WaybillFieldCheckboxGroup: React.FC<WaybillFieldCheckboxGroupProps> = ({
    value = [],
    totalExportItems = Object.values(WaybillNoExportExportItem),
    onChange,
    needProductInfo,
    editable,
}) => {
    return (
        <Checkbox.Group className={styles.waybillFieldGroup} value={value} onChange={onChange}>
            <Row>
                {totalExportItems.map((field) => {
                    const disabled = !needProductInfo && WaybillNoExportExportProductFields.includes(field);
                    const checked = value.includes(field);
                    return (
                        <WaybillFieldItem
                            key={field}
                            value={field}
                            checked={checked}
                            disabled={disabled}
                            editable={editable}
                        />
                    );
                })}
            </Row>
        </Checkbox.Group>
    );
};
